<template>
  <div id="photoGallery">
    <el-dialog title="选择图片"  width="855px" @closed="closeDialog" :visible.sync="dialogVisibleSelf">
      <div>1选择素材——2裁切图片</div>
      <div style="display:flex;">
        <div style="width:100%; margin-top:10px;">
          <div style="display:flex;">
            <el-input
              style="width:300px;margin-right:20px;"
              placeholder="请输入内容"
              v-model="filterText"
              class="input-with-select"
            >
              <el-select
                style="width:80px;"
                @change="changeCategory"
                v-model="currentCategoryId"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option
                  v-for="(c,index) in categories"
                  :key="index"
                  :label="c.name"
                  :value="c.id"
                ></el-option>
              </el-select>
              <el-button slot="append" @click="getPhotoList" :loading="dataLoading" icon="el-icon-search"></el-button>
            </el-input>
            <el-button type="primary" @click="innerVisible=true">本地上传</el-button>
          </div>
          <div>
            <ul id="photoGalleryContainer" :loading="dataLoading">
              <li v-for="(item,index) in photoList" :key="index" @click="currentPhoto = item">
                <div class="photo-item" :class="{'select':item == currentPhoto}">
                  <el-image  show-overflow-tooltip style="width:100px;height:100px;" :alt="item.name" :src="item.picUrl+'?imageslim'">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <div  style="width: 100px;white-space: nowrap;word-break: break-all;text-overflow: ellipsis;overflow: hidden;">{{item.name}}</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="block">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageInfo.currentPage"
              :page-sizes="[8]"
              :page-size="pageInfo.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageInfo.total"
            ></el-pagination>
          </div>
        </div>
        <div style="width:200px;scroll-y:auto;height:470px;overflow-x: hidden;">
          <div
            v-for="(c,index) in categories"
            style="padding: 15px;width:100%;"
            @click="selectCategory(c)"
            :class="{'category-selected':currentCategory==c}"
            :key="index"
          >{{c.name}}[{{c.count}}]</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleSelf=false">取消</el-button>
        <el-button v-if="!originalImg" type="primary" @click="nextAction">下一步</el-button>
        <el-button v-if="originalImg" type="primary" @click="confirmImage">确定</el-button>
      </div>
      <el-dialog title="添加图片" :visible.sync="innerVisible" append-to-body>
        <el-form :model="photoForm">
          <el-form-item label="名称" label-width="80px">
            <el-input v-model="photoForm.name" placeholder="请输入素材名称" />
          </el-form-item>
          <el-form-item label="分类" label-width="80px">
            <el-select v-model="photoForm.typeid" placeholder="请选择分类">
              <el-option v-for="i in categories" :key="i.id" :label="i.name" :value="i.id"></el-option>
            </el-select>
            <el-tag @click="innerCategoryVisible=true">添加</el-tag>
          </el-form-item>
          <el-form-item class="is-required" label="图片">
            <el-upload
              ref="upload"
              action="/api/sysConfig/upload"
              class="icon-uploader"
              list-type="picture-card"
              :accept="'image/*'"
              :limit="1"
              :on-success="uploadSharePicSuccess"
              :auto-upload="true"
              :file-list="fileList"
            >
              <i class="el-icon-plus icon-uploader-icon"></i>
            </el-upload>
            <span>JPG、PNG格式， 图片小于5M。</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible=false">取消</el-button>
          <el-button type="primary" @click="savePhoto" v-loading="photoAction">提交</el-button>
        </div>

        <el-dialog title="添加分类" :visible.sync="innerCategoryVisible" append-to-body>
          <el-form :model="categoryForm">
            <el-form-item label="名称" label-width="80px">
              <el-input v-model="categoryForm.name" placeholder="请输入分类名称" />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="innerCategoryVisible=false">取消</el-button>
            <el-button type="primary" @click="saveCategory" v-loading="categoryAction">提交</el-button>
          </div>
        </el-dialog>
      </el-dialog>
    </el-dialog>
    <el-dialog title="裁剪" :visible.sync="cropperPhotoVisible">
      <div class="cropper-content">
        <div class="cropper">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :info="true"
                :outputSize="option.outputSize"
                :outputType="option.outputType"
                :canMove="option.canMove"
                :autoCrop="option.autoCrop"
                :autoCropWidth="cropWidth"
                :autoCropHeight="cropHeight"
                :fixedBox="option.fixedBox"
                :original="option.original"
                :infoTrue="option.infoTrue"
                :centerBox="option.centerBox"
                :canMoveBox="option.canMoveBox"
                :canScale="option.canScale"
                :fixed="option.fixed"
                :full="option.full"
                :enlarge="option.enlarge"
                :fixedNumber="[cropWidth/100,cropHeight/100]"
            @realTime="realTime"
            @imgLoad="imgLoad"
          ></vueCropper>
        </div>
        <div
          class="show-preview"
          :style="{'width': previews.w + 'px', 'height': previews.h + 'px',  'overflow': 'hidden', 'margin': '5px'}"
        >
          <div :style="previews.div" class="preview">
            <img :src="previews.url" :style="previews.img" />
          </div>
        </div>
      </div>

      <div class="footer-btn">
        <div class="scope-btn">
          <label class="btn" @click="cropperPhotoVisible=false;">更换图片</label>
          <button @click="changeScale(1)">+</button>
          <button @click="changeScale(-1)">-</button>
          <button @click="rotateLeft">↺</button>
          <button @click="rotateRight">↻</button>
        </div>
        <div class="upload-btn">
          <el-button
            type="primary"
            size="mini"
            @click="uploadCropperImg('blob')"
            v-loading="uploadImageing"
          >上传</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import httpRequest from "../../utils/httpRequest";
import { VueCropper } from "vue-cropper";
import qs from "qs";
export default {
  components: { VueCropper },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    cropWidth:{
      type: Number,
      default: 343
    },
    cropHeight:{
      type: Number,
      default: 193
    },
    originalImg:{
      type: Boolean,
      default:false
    }
  },
  data() {
    return {
      categories: [{ name: "全部", count: 0, id: 0 }],
      dialogVisibleSelf: this.dialogVisible,
      photoList: [],
      cropperPhotoVisible: false,
      dataLoading:false,
      currentCategory: {},
      currentCategoryId: 0,
      currentPhoto: undefined,
      photoAction: false,
      categoryAction: false,
      innerCategoryVisible: false,
      categoryForm: {},
      filterText: "",
      photoForm: {typeid:0},
      fileList: [],
      innerVisible: false,
      uploadImageing: false,
      pageInfo: {
        currentPage: 1,
        pageSize: 8,
        total: 0
      },
      crap: false,
      previews: {},
      option: {
        img: "",
        size: 1,
        full: true, //输出原图比例截图 props名full
        //fixedBox: true,
        outputSize: 1, // 裁剪生成图片的质量 0.1 - 1
        outputType: 'png', //	裁剪生成图片的格式 jpeg || png || webp
        canScale: true, // 图片是否允许滚轮缩放 默认true
        autoCrop: true, // 是否默认生成截图框 默认false
        canMove: true, //上传图片是否可以移动 默认true
        //autoCropWidth: 200, //默认生成截图框宽度	容器的80%	0~max
        //autoCropHeight: 200, //默认生成截图框高度	容器的80%	0~max
        fixedBox: true, // 固定截图框大小 不允许改变	false	true | false
        fixed: true, //是否开启截图框宽高固定比例
        original: false, // 上传图片按照原始比例渲染	false	true | false
        infoTrue: false, // 为展示真实输出图片宽高 false 展示看到的截图框宽高	false	true | false
        centerBox: true, // 截图框是否被限制在图片里面	false	true | false
        canMoveBox: true, //截图框能否拖动	true	true | false
       // fixedNumber: [1, 1] // 截图框的宽高比例 [宽度, 高度]
       enlarge:3
      },
      downImg: "#"
    };
  },
  created() {
    this.getCategories();
    this.getPhotoList();
  },
  methods: {
    open(){
      this.dialogVisibleSelf = true
    },
    changeScale(num) {
      this.$refs.cropper.changeScale(num);
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    finish(type) {
      // 输出 //
      var test = window.open("about:blank"); // test.
      document.body.innerHTML = "图片生成中..";
      if (type === "blob") {
        this.$refs.cropper.getCropBlob(data => {
          var img = window.URL.createObjectURL(data);
          this.model = true;
          this.modelSrc = img;
        });
      } else {
        this.$refs.cropper.getCropData(data => {
          this.model = true;
          this.modelSrc = data;
        });
      }
    }, 
    confirmImage(path){
      this.$emit("setImgPath", this.currentPhoto.picUrl);
      this.dialogVisibleSelf = false;
    },
    // 实时预览函数
    uploadCropperImg(type) {
      // event.preventDefault()
      const that = this;
      if (type === "blob") {
        this.$refs.cropper.getCropBlob(data => {
          this.downImg = window.URL.createObjectURL(data); //
          const formData = new FormData();
          formData.append("file", data);
          that.uploadImageing = true;
          httpRequest
            .upload("/api/sysConfig/upload", formData, {
              contentType: false,
              processData: false,
              headers: { "Content-Type": "application/x-www-form-urlencoded" }
            })
            .then(res => {
              this.$emit("setImgPath", res.data);
              that.uploadImageing = false;
              that.cropperPhotoVisible = false;
              that.dialogVisibleSelf = false;
            })
            .catch(e => {
              console.log(e);
              that.uploadImageing = false;
            });
        });
      }
    },
    realTime(data) {
      console.log(data)
      this.previews = data;
    },
    changeCategory(v) {
      console.log(v);
      const d = this.categories.filter(c => c.id == v);
      this.selectCategory(d[0]);
      this.pageInfo.currentPage =1;
      this.getPhotoList();
    },
    selectCategory(c) {
      this.currentCategory = c;
      this.currentCategoryId = c.id;
      this.getPhotoList();
    },
    uploadImg(e, num) {
      //上传图片 //
      this.option.img;
      var file = e.target.files[0];
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
        return false;
      }
      var reader = new FileReader();
      reader.onload = e => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        if (num === 1) {
          this.option.img = data;
        } else if (num === 2) {
          this.example2.img = data;
        }
      }; // 转化为base64 //
      reader.readAsDataURL(file); // 转化为blob
      reader.readAsArrayBuffer(file);
    },
    imgLoad(msg) {
      console.log('imgLoad',msg)
    },
    getCategories() {
      httpRequest
        .get("/api/sourceMaterial/getMaterialTypeInfo")
        .then(res => {
          if (res.data.list) {
            let count = 0;
            var list = res.data.list.map(item => {
              count += item.count;
              return {
                id: item.id,
                count: item.count,
                name: item.typeName
              };
            });
            this.categories[0].count = count;
            let newCate = [];
            newCate.push(this.categories[0]);
            newCate.push(...list);
            this.categories = newCate;
            this.currentCategory = this.categories[0];
          }
          // this.dataLoading = false;
        })
        .catch(e => {
          console.log(e);
          // this.dataLoading = false;
        });
    },
    getPhotoList() {
      let data = { name: this.filterText };
      // if (this.currentCategory.id > 0) {
      //   data = { id: this.currentCategory.id + "", name: this.filterText };
      // }
      if(!data.name){
        delete data.name
      }
      if (this.currentCategory.name && this.currentCategory.name !='全部'){
        data.typename=this.currentCategory.name
      }
      this.dataLoading=true;
      httpRequest
        .post("/api/sourceMaterial/getSourceMaterialList?"+qs.stringify(this.pageInfo), data)
        .then(res => {
          var list = res.data.list;
          if(location.href.indexOf('https:')>=0){
            list = list.map(item=>{
               item.picUrl = item.picUrl.replace('http:','https:');
               return item;
            })
          }
          console.log(list)
          this.photoList = list;
          this.pageInfo.total = res.data.total;
          this.dataLoading = false;
        })
        .catch(e => {
          console.log(e);
          this.dataLoading = false;
        });
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    uploadSharePicSuccess(res, file) {
      this.photoForm.picurl = res;
    },
    saveCategory() {
      if (this.categoryForm.name) {
        this.categoryAction = true;
        httpRequest
          .get(
            "/api/sourceMaterial/createMaterialType?typename=" +
              this.categoryForm.name
          )
          .then(res => {
            this.getCategories();
            this.categoryAction = false;
            this.innerCategoryVisible = false;
            this.categoryForm.name = "";
          })
          .catch(e => {
            console.log(e);
            // this.dataLoading = false;
            this.categoryAction = false;
          });
      }
    },
    savePhoto() {
      if (
        !this.photoForm.name ||
        !(this.photoForm.typeid>=0) ||
        !this.photoForm.picurl
      ) {
        this.$message.error("请填写完整素材信息");
        return;
      } 
      const c = this.categories.find(i=>i.id == this.photoForm.typeid);
      console.log(this.categories,c,this.photoForm)
      this.photoForm.typename = c.name;
      this.categoryAction = true;
      let pForm = Object.assign({},this.photoForm);
      pForm.typeid = this.photoForm.typeid.toString()
      httpRequest
        .get("/api/sourceMaterial/createSourceMaterial", pForm)
        .then(res => {
          this.getCategories();
          this.getPhotoList();
          this.photoAction = false;
          this.innerVisible = false;
          this.photoForm.name = "";
          this.photoForm.typeid = "";
          this.photoForm.picurl = "";
          this.fileList = [];
        })
        .catch(e => {
          console.log(e);
          // this.dataLoading = false;
          this.photoAction = false;
        });
    },
    //每页展示数据条数改变
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getPhotoList();
    },
    //页码改变
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.getPhotoList();
    },
    nextAction() {
      if (!this.currentPhoto) {
        this.$message.error("请选择图片");
        return;
      }
      this.cropperPhotoVisible = true;
      console.log( this.currentPhoto)
      this.option.img = this.currentPhoto.picUrl;
    }
  },
  mounted() {
    this.dialogVisibleSelf = this.dialogVisible;
  },
  watch: {
    dialogVisible(newVal, oldVal) {
      this.dialogVisibleSelf = this.dialogVisible;
    }
  }
};
</script>
<style scoped>
#photoGalleryContainer li {
  display: inline;
  line-height: 24px;
  height: auto;
  word-break: break-all;
  word-wrap: break-word;
  text-align: center;
}
#photoGalleryContainer li .photo-item {
  widows: 100px;
  display: inline-block;
  margin-right: 20px;
  margin-top: 20px;
  border: 1px solid #ebeef5;
  padding: 15px;
}
.select {
  border: 1px solid #67c23a !important;
}
.cropper-content {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
.cropper-content .cropper {
  width: 350px;
  height: 300px;
}
.cropper-content .show-preview {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
}
.cropper-content .show-preview .preview {
  overflow: hidden;
  border: 1px solid #cccccc;
  background: #cccccc;
  margin-left: 40px;
  width: 120px;
  height: 67.5px;
}
.footer-btn {
  margin-top: 30px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
.footer-btn .scope-btn {
  width: 350px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
.footer-btn .upload-btn {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
}
.footer-btn .btn {
  outline: none;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 12px;
  border-radius: 3px;
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
.category-selected {
  background-color: #dcdfe6;
}
</style>


// WEBPACK FOOTER //
// src/components/plugin/photo-gallery.vue